import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../api.service";

const PATH = "logic-tree-tests";

export type LogicTreeTestStatus =
  | "pending"
  | "queued"
  | "running"
  | "completed"
  | "failed";

export interface LogicTreeTest {
  id: number;
  account_id: number;
  account_app_id: number;
  logic_tree_id: number;
  created_by: number;
  created_at: string;
  queued_at: string | null;
  started_at: string | null;
  completed_at: string | null;
  deleted_at: string | null;
  status: LogicTreeTestStatus;
  config: Record<string, any>;
  result: Record<string, any>;
  entities: Record<string, any>;
  error: string | null;
  logic_tree?: any;
  created_by_user?: any;
}

export interface LogicTreeTestListResponse {
  records: LogicTreeTest[];
  page?: number;
  per_page?: number;
  count?: number;
}

@Injectable({
  providedIn: "root",
})
export class LogicTreeTestsHandlerService {
  constructor(private APIService: ApiService) {}

  /**
   * List tests for an account, sorted by created_at DESC (server-enforced).
   */
  listLogicTreeTests(
    masterAccountID: number,
    queryParams?: {
      account_app_id?: number;
      logic_tree_id?: number;
      page?: number;
      perPage?: number;
    },
  ): Observable<LogicTreeTestListResponse | LogicTreeTest[]> {
    return this.APIService.get(`${PATH}/${masterAccountID}`, {
      params: queryParams,
    });
  }

  getLogicTreeTest(
    masterAccountID: number,
    logicTreeTestID: number,
  ): Observable<LogicTreeTest> {
    return this.APIService.get<LogicTreeTest>(
      `${PATH}/${masterAccountID}/${logicTreeTestID}`,
    );
  }

  createLogicTreeTest(
    masterAccountID: number,
    body: { logic_tree_id: number; config?: Record<string, any> },
  ): Observable<LogicTreeTest> {
    return this.APIService.post<LogicTreeTest>(`${PATH}/${masterAccountID}`, body);
  }

  deleteLogicTreeTest(
    masterAccountID: number,
    logicTreeTestID: number,
  ): Observable<void> {
    return this.APIService.delete<void>(
      `${PATH}/${masterAccountID}/${logicTreeTestID}`,
    );
  }
}
